import hkConfig from './hk'
import thConfig from './th'

/** @type {'hk'|'th'} */
const REACT_APP_REGION = process.env.REACT_APP_REGION || 'hk'

/** @type {Record<string, IConfig>} */
const configs = {
  hk: hkConfig,
  th: thConfig,
}

const exportConfig = configs[REACT_APP_REGION] || hkConfig

export default exportConfig
